// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3zCYC","socialIcons":"footer-module--socialIcons--ikr5r","legal":"footer-module--legal--EHT7t","credits":"footer-module--credits--3VKT3"};